import React, { Component } from 'react';
import moment from 'moment'
import {
  Row,
  Col,
  Card,
  Form, FormGroup, Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupButton,
  CardHeader,
  CardBody,
  CardFooter,
  CardGroup,
  Collapse, Button, Fade, Jumbotron,
  ListGroup, ListGroupItem, ListGroupItemHeading, ListGroupItemText,
  Table
} from 'reactstrap';

import $ from "jquery";
var JSONViewer = require('react-json-viewer');
import ReactJson from 'react-json-view'
const v = require('voca');
import { makeInput } from "common-import/custom";
import { MobXHelper, Request, VarHelper } from "common-import/helpers";
import { inject, observer } from "mobx-react";

const propertyBidding = ["approved", "bidCloseTime", "bidOpenTime", "createdAt", "createdByType", "name", "numOfBiddingProcess", "numOfReceivedBids", "numOfSentInvitations", "preferredCurrency", "status", "typeOfBid", "updatedAt"];
let initialState = {};
propertyBidding.forEach(val => initialState[val] = "");

@inject("biddingCategoryStore", "userStore") @observer
class BiddingProfile extends Component {

  constructor(props) {
    super(props);
    this.state = {
      bidding: initialState,
      current: initialState,
    }
  }

  async componentDidMount() {
    await this.props.userStore.onReady();
    this.getBiddingDetail();
  }

  getBiddingDetail = async () => {
    const { biddingCategoryStore, match } = this.props;
    const { currentBidding } = biddingCategoryStore;
    this.setState({ project: currentBidding, current: currentBidding })
    console.log('ID', match.params.id)
    biddingCategoryStore.setCurrentBidding(match.params.id);
    // let project = await biddingCategoryStore.getProjectDetail(match.params.id);
    // this.setState({ project });
  }

  approveProject = async e => {
    e.preventDefault();
    const { biddingCategoryStore, match } = this.props;
    let continueApprove = confirm("Bạn có chắc chắn muốn xác thực hạng mục đấu thầu này?");
    if(continueApprove) {
      // alert("Chức năng xác thực đang hoàn thiện");
      let result = await biddingCategoryStore.approve({ id: match.params.id, approved: true });
      if (!!result.error) return window.toast.error("Có lỗi xảy ra, vui lòng thử lại   " + JSON.stringify(result.error));
      window.toast.info("Duyệt hạng mục đấu thầu thành công");
      // this.setState({ contractor: { ...this.state.contractor, approved: 1 } })
      biddingCategoryStore.currentBidding = {...biddingCategoryStore.currentBidding, approved: 1};
    }
  }

  renderApprove = () => {
    const { biddingCategoryStore, match } = this.props;
    const { currentBidding } = biddingCategoryStore;
    const { approved } = currentBidding;
    if (approved === undefined || approved === "" || approved === true || approved === 1) return null;
    return (
      <Row style={{ marginBottom: 30 }}>
        <Col xs="12" md="12" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
          <h3 style={{ marginRight: 10 }}>Hạng mục đấu thầu này chưa được duyệt.</h3>
          <Button style={{ display: "inline-block" }} type="submit" size="sm" color="primary" onClick={this.approveProject}><i className="fa fa-dot-circle-o"></i> Duyệt</Button>
        </Col>
      </Row>
    )
  }

  renderBiddingForm = (form) => {
    if (!form || !form.id) {
      return;
    }
    return (
      <Form action="" method="post" onSubmit={e => e.preventDefault()}>
        {
          propertyBidding.map((property, index) => {
            return (
              <FormGroup key={"property" + index}>
                <Label htmlFor={"nf-" + property}>{v.capitalize(property)}:</Label>
                {/* {makeInput(this, property)(<Input type="text" id={"nf-" + property} name={"nf-" + property} />)} */}
                <Input
                  type="text"
                  id={"nf-" + property}
                  name={"nf-" + property}
                  value={this.state.current[property]}
                  onChange={e => this.setState({
                    current: { ...this.state.current, [property]: e.target.value }
                  })}
                 />
              </FormGroup>
            );
          })
        }
      </Form>
    )
  }

  render() {
    const { biddingCategoryStore, match } = this.props;
    const { currentBidding } = biddingCategoryStore;
    const projectId = this.props.match.params.id;
    return (
      <div className="animated fadeIn">
        {this.renderApprove()}
        <Row>
          <Col xs="12" md="12">
            <Card>
              <CardHeader>
                <i className="fa fa-envelope-open"></i>Thông tin của hạng mục đấu thầu: <strong>{currentBidding.name}</strong>
              </CardHeader>
              <CardBody>
                {this.renderBiddingForm(currentBidding)}
                <Row>
                  <Col xs="12" md="12" >
                    {/* <div style={{overflowX:'auto'}}>
                      <JSONViewer json={currentProject} />
                    </div> */}
                    {/* <ReactJson
                      src={currentBidding}
                      name={currentBidding.name}
                      displayDataTypes={false}
                      theme={"ocean"}
                    /> */}

                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <Button type="submit" size="sm" color="primary" onClick={this.editProfile}><i className="fa fa-dot-circle-o"></i> Save</Button>
                <Button type="reset" size="sm" color="danger"><i className="fa fa-ban"></i> Cancel</Button>
              </CardFooter>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default BiddingProfile;



// WEBPACK FOOTER //
// ./src/views/Bidding/BiddingDetail.js